import { render } from "./corpper.vue?vue&type=template&id=d46fb3c2&scoped=true"
import script from "./corpper.vue?vue&type=script&lang=js"
export * from "./corpper.vue?vue&type=script&lang=js"

import "./corpper.vue?vue&type=style&index=0&id=d46fb3c2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d46fb3c2"]])

export default __exports__